// @flow
import { Capacitor } from "@capacitor/core";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router";
import { getRouteUrl } from "../helpers/getRouteUrl";
import useUserData from "../hooks/user/useUserData";
import { ROUTE_PAGE_LOGIN } from "../routers/routes";

import {Box, useMediaQuery} from "@mui/material";

import { LANDING } from "./locales/namespaces";
import HeroMobile from "./components/landing/Hero/heroMobile";
import Hero from "./components/landing/Hero";
import MobileApp from "./components/landing/MobileApp";
import BankLogos from "./components/landing/BankLogos";
import Reviews from "./components/landing/Reviews";
import Footer from "./components/landing/Footer";
// helpers
import { getCanonicalUrl } from "../helpers/helpers";

const Landing = () => {
  const { t } = useTranslation(LANDING);
  const {isLoggedIn} = useUserData();
  const canonicalUrl = getCanonicalUrl('/');

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);

  // if(!isLoggedIn && Capacitor.isNativePlatform()) {
  //     return <Redirect to={getRouteUrl(ROUTE_PAGE_LOGIN)}/>
  // }
  //
  return (
    <>
      <Helmet>
        <title>{t("IMS FC - Online Mortgage Loan")}</title>
        <meta
          name="description"
          content={t("Online mortgage loan from IMS. Discover specialized financing solutions for foreign residents from the largest credit broker in Greece. Complete the entire process from your mobile!")}
        />
        <meta
          property="og:title"
          content={t("IMS FC - Online Mortgage Loan")}
        />
        <meta
          property="og:description"
          content={t("Online mortgage loan from IMS. Discover specialized financing solutions for foreign residents from the largest credit broker in Greece. Complete the entire process from your mobile!")}
        />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <style>{`body { background-color: #fff; }`}</style>


      {Capacitor.isNativePlatform() &&
        <HeroMobile />
      }
      {!Capacitor.isNativePlatform() &&
        <Box className="landing-page">
          <Hero />
          <MobileApp />
          <BankLogos />
          <Reviews />
          <Footer />
        </Box>
      }
    </>
  )
}

export default Landing;
